import { Injectable } from '@angular/core';
import { Accessibility, IAccessibilityOptions } from 'accessibility';
import { TranslocoService } from '@ngneat/transloco';

@Injectable({
  providedIn: 'root'
})
export class AccessibilityService {
  private accessibility: Accessibility | undefined;

  constructor(private translocoService: TranslocoService) {}

  initAccessibility() {
    this.translocoService
      .selectTranslateObject('accessibility')
      .subscribe((translations) => {
       this.initializeAccessibility(translations);
      });
  }

  initializeAccessibility(translations: any) {
    if (this.accessibility) {
      this.accessibility.destroy();
    }
    const options: IAccessibilityOptions = {
      modules: {
        increaseText: true,
        decreaseText: true,
        invertColors: true,
        increaseTextSpacing: true,
        decreaseTextSpacing: true,
        increaseLineHeight: true,
        decreaseLineHeight: true,
        grayHues: true,
        underlineLinks: true,
        bigCursor: true,
        readingGuide: true,
        textToSpeech: false,
        speechToText: false,
        disableAnimations: false
      },
      /**
       * t(accessibility.close_title, accessibility.reset_title, accessibility.close_title, accessibility.menu_title, accessibility.increase_text, accessibility.decrease_text, accessibility.increase_text_spacing, accessibility.decrease_text_spacing, accessibility.increase_line_height, accessibility.decrease_line_height, accessibility.invert_colors, accessibility.gray_hues, accessibility.underline_links, accessibility.big_cursor, accessibility.reading_guide, accessibility.text_to_speech, accessibility.speech_to_text, accessibility.disable_animations, accessibility.hotkey_prefix)
       */
      labels: {
        resetTitle: translations['reset_title'],
        closeTitle: translations['close_title'],
        menuTitle: translations['menu_title'],
        increaseText: translations['increase_text'],
        decreaseText: translations['decrease_text'],
        increaseTextSpacing: translations['increase_text_spacing'],
        decreaseTextSpacing: translations['decrease_text_spacing'],
        increaseLineHeight: translations['increase_line_height'],
        decreaseLineHeight: translations['decrease_line_height'],
        invertColors: translations['invert_colors'],
        grayHues: translations['gray_hues'],
        underlineLinks: translations['underline_links'],
        bigCursor: translations['big_cursor'],
        readingGuide: translations['reading_guide'],
        textToSpeech: translations['text_to_speech'],
        speechToText: translations['speech_to_text'],
        disableAnimations: translations['disable_animations'],
        hotkeyPrefix: translations['hotkey_prefix'],
      },
      icon: {
        img: 'accessibility',
      }
    };
    this.accessibility = new Accessibility(options);
  }
}
